module.exports = __webpack_public_path__ + "static/GT-America-Standard-Regular-4d77827602d00646fb9ffe934279a67e.woff2";